module.exports = __webpack_public_path__ + "img/Rolling10_pdf.897064aa.png";